export enum LimitFrequency {
  per24HourPeriod = 'per24HourPeriod',
  perMonth = 'perMonth',
}

export enum CardType {
  physical = 'physical',
  virtual = 'virtual',
}

export enum CardStatus {
  active = 'active',
  notActivated = 'notActivated',
}

export interface ICardLimit {
  amount?: number;
  frequency?: LimitFrequency;
}

export interface ICardConfiguration {
  displayName?: string;
  productId?: number;
  productRef?: string;
}

export interface IAddress {
  line1?: string;
  line2?: string;
  city?: string;
  region?: string;
  postalCode?: string;
  countryCode?: string;
  country?: string;
}

export interface IShipping extends IAddress {
  phoneNumber?: string;
}

export interface INewCoreProduct {
  id: string;
}

export interface ICreateVirtualCardData {
  customerId: string;
  virtualCardTypeId: string;
  activityId?: string;
  amount?: number;
  product?: INewCoreProduct;
  expiration?: Date;
  crmProjectId: number;
  type: CardType;
  status: CardStatus;
  limit?: ICardLimit;
  configuration?: ICardConfiguration;
  shipping?: IShipping;
  billing?: IAddress;
}
